import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const LinkedInIcon: IconComponent = ({ className, colorCode = 'p500', width = 25, height = 26 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 25 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.03323 0.939453C1.19945 0.939453 0 2.19814 0 3.85337C0 5.47252 1.16475 6.76941 2.96209 6.76941H2.99789C4.86719 6.76941 6.02973 5.47276 6.02973 3.85337C5.99451 2.19814 4.86719 0.939453 3.03323 0.939453ZM24.9996 16.2672V25.9397H19.641V16.915C19.641 14.6479 18.8659 13.1007 16.9263 13.1007C15.4456 13.1007 14.5645 14.1434 14.1768 15.1521C14.0355 15.5126 13.9991 16.0145 13.9991 16.5193V25.9397H8.63867C8.63867 25.9397 8.71087 10.6548 8.63867 9.07118H13.9985V11.4622C13.9934 11.4707 13.9876 11.4794 13.9818 11.4881L13.9817 11.4882C13.9752 11.4979 13.9687 11.5076 13.9633 11.5167H13.9985V11.4622C14.7107 10.3145 15.9824 8.6749 18.829 8.6749C22.3557 8.67483 24.9996 11.0858 24.9996 16.2672ZM5.67672 25.9388H0.318359V9.0703H5.67672V25.9388Z"
                fill={color}
            />
        </svg>
    )
}
